var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLOprofileNotSelected = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6150_44403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92862 9.81703C10.5904 9.81703 11.1634 9.57968 11.6317 9.11139C12.0999 8.64317 12.3372 8.07028 12.3372 7.40844C12.3372 6.74682 12.0999 6.17385 11.6316 5.70549C11.1633 5.23735 10.5903 5 9.92862 5C9.26677 5 8.69388 5.23735 8.22566 5.70556C7.75745 6.17378 7.52002 6.74674 7.52002 7.40844C7.52002 8.07028 7.75745 8.64325 8.22574 9.11146C8.69403 9.5796 9.267 9.81703 9.92862 9.81703Z",
    fill: "#A8B1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1431 12.6897C14.1296 12.4948 14.1023 12.2823 14.0621 12.0578C14.0215 11.8317 13.9693 11.6179 13.9067 11.4225C13.8421 11.2206 13.7542 11.0211 13.6456 10.83C13.5328 10.6316 13.4003 10.4589 13.2517 10.3168C13.0963 10.1681 12.906 10.0485 12.686 9.96133C12.4667 9.87459 12.2237 9.83064 11.9638 9.83064C11.8617 9.83064 11.763 9.87253 11.5723 9.99666C11.455 10.0732 11.3177 10.1617 11.1646 10.2596C11.0336 10.343 10.8561 10.4212 10.6369 10.492C10.423 10.5612 10.2059 10.5963 9.99161 10.5963C9.7773 10.5963 9.56024 10.5612 9.34616 10.492C9.1272 10.4213 8.94974 10.3431 8.81889 10.2596C8.66714 10.1627 8.52982 10.0742 8.41072 9.99658C8.22029 9.87245 8.12149 9.83057 8.01941 9.83057C7.7594 9.83057 7.51648 9.87459 7.29729 9.96141C7.07741 10.0485 6.88705 10.168 6.73149 10.3169C6.58295 10.4591 6.45042 10.6317 6.33781 10.83C6.22925 11.0211 6.14136 11.2205 6.07666 11.4226C6.01418 11.618 5.96191 11.8317 5.92133 12.0578C5.88112 12.282 5.85381 12.4946 5.8403 12.6899C5.82703 12.8812 5.82031 13.0798 5.82031 13.2804C5.82031 13.8024 5.98625 14.225 6.31348 14.5367C6.63666 14.8442 7.06429 15.0002 7.5843 15.0002H12.3994C12.9194 15.0002 13.3469 14.8443 13.6701 14.5367C13.9974 14.2252 14.1634 13.8026 14.1634 13.2803C14.1633 13.0788 14.1565 12.8801 14.1431 12.6897Z",
    fill: "#A8B1C1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V5",
    stroke: "#A8B1C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 1H17.001C17.5314 1 18.0401 1.21071 18.4152 1.58579C18.7903 1.96086 19.001 2.46957 19.001 3V5",
    stroke: "#A8B1C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V15",
    stroke: "#A8B1C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 19H17.001C17.5314 19 18.0401 18.7893 18.4152 18.4142C18.7903 18.0391 19.001 17.5304 19.001 17V15",
    stroke: "#A8B1C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6150_44403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLOprofileNotSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LOprofileNotSelected.36460f8d687557c03350fd21459a0e15.svg";